import {ErrorBoundary} from "commons";
import React, {Suspense} from "react";
import {Loader} from "../common/Loader";
import { Etudes } from "components/etudes/Etudes";


export const EtudesView = () => {
    return (<div className="mx-3 mb-5">
        <ErrorBoundary>
            <Suspense fallback={<div className="d-flex justify-content-center">
                <Loader/>
            </div>}>
                <Etudes/>
            </Suspense>
        </ErrorBoundary>
    </div>)
}